/**
 * Analytics — thin wrapper over Google Analytics 4 (gtag.js).
 *
 * The gtag.js loader is added in public/index.html and configures the property
 * with { send_page_view: false }. This module fires page_views manually on
 * every React Router navigation and provides typed helpers for custom events.
 *
 * Safe to call even if gtag isn't loaded (e.g. adblock) — all helpers no-op.
 */

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-M1G85R2JMX';

const canTrack = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

/** Fire a page_view event for the current SPA route. */
export const trackPageView = (path) => {
  if (!canTrack()) return;
  window.gtag('config', GA_ID, {
    page_path: path,
    page_title: document.title,
    page_location: window.location.href,
  });
};

/** Fire a custom event (typically for conversions). */
export const trackEvent = (name, params = {}) => {
  if (!canTrack()) return;
  window.gtag('event', name, params);
};

/** GA4 e-commerce "purchase" event — flows into Monetization reports. */
export const trackPurchase = ({ orderId, value, items = [] }) => {
  trackEvent('purchase', {
    transaction_id: orderId,
    value,
    currency: 'ZAR',
    items,
  });
};
